import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { CardContent } from '../../CardContent';
import ButtonDefault from '@/components/ui/ButtonDefault';
import { useHandleActions } from './hooks/useHandleActions';
import { VideoSelection } from '../../components/VideoSelection';
import { ToastError } from '../../components/ToastError';

export function VideoSelectionStep() {
	const { handleValidateFileList, filesQty, isEnabledNotification, isEnabledMessageFilesQty } = useHandleActions();

	const filesQuantityMsg = I18n.get('filesQuantity').replace('{{qty}}', filesQty.toString());

	return (
		<Row justify="center" align="middle" gutter={[0, 32]}>
			{isEnabledNotification && <ToastError message={'Please select one or more videos before continuing'} />}
			{isEnabledMessageFilesQty && <ToastError message={filesQuantityMsg} />}
			<Col span={24}>
				<CardContent>
					<VideoSelection />
				</CardContent>
			</Col>
			<Col>
				<ButtonDefault type="primary" onClick={handleValidateFileList}>
					{I18n.get('Next')}
				</ButtonDefault>
			</Col>
		</Row>
	);
}
